import { defineMessages } from 'react-intl';

const Messages = defineMessages({
  //#region Agent conversion labels

  //new
  agentConversionPage_title: {
    id: 'agentConversionPage_title',
    defaultMessage: 'Agent conversions',
  },
  //translated
  agentConversionPage_statistics: {
    id: 'agentConversionPage_statistics',
    defaultMessage: 'Conversion statistics',
  },
  //new
  agentConversionPage_convertedAgentsTitle: {
    id: 'agentConversionPage_convertedAgentsTitle',
    defaultMessage: 'Agents',
  },
  //translated
  agentConversionPage_oldCode: {
    id: 'agentConversionPage_oldCode',
    defaultMessage: 'Old code',
  },
  //translated
  agentConversionPage_newCode: {
    id: 'agentConversionPage_newCode',
    defaultMessage: 'New code',
  },
  //translated
  agentConversionPage_mappingDisabledNotification: {
    id: 'agentConversionPage_mappingDisabledNotification',
    defaultMessage: 'Mapping disabled for: {oldCode}​​​​​​​ => {newCode} ',
  },
  //new
  agentConversionPage_mappingErrorNotification: {
    id: 'agentConversionPage_mappingErrorNotification',
    defaultMessage: 'Error occured during mapping: {oldCode} => {newCode}',
  },
  //translated
  agentConversionPage_mappingEnabledNotification: {
    id: 'agentConversionPage_mappingEnabledNotification',
    defaultMessage: 'Mapping done for: {oldCode} => {newCode}',
  },
  //translated
  agentConversionPage_enable: {
    id: 'agentConversionPage_enable',
    defaultMessage: 'Enable',
  },
  //translated
  agentConversionPage_disable: {
    id: 'agentConversionPage_disable',
    defaultMessage: 'Disable',
  },
  //translated
  agentConversionPage_channelNameInUserMetadata: {
    id: 'agentConversionPage_channelNameInUserMetadata',
    defaultMessage: 'Channel name in Usermetadata',
  },
  //translated
  agentConversionPage_channelNameInWayPoint: {
    id: 'agentConversionPage_channelNameInWayPoint',
    defaultMessage: 'Channel name in Waypoint',
  },
  //translated
  agentConversionPage_glCode: {
    id: 'agentConversionPage_glCode',
    defaultMessage: 'GL Code',
  },
  //translated
  agentConversionPage_agentsInUserMetadata: {
    id: 'agentConversionPage_agentsInUserMetadata',
    defaultMessage: 'Sales codes in Usermetadata',
  },
  //translated
  agentConversionPage_convertedAgentsToWayPoint: {
    id: 'agentConversionPage_convertedAgentsToWayPoint',
    defaultMessage: 'Converted sales codes to Waypoint',
  },
  //translated
  agentConversionPage_convertedAgentsInRenewalStep: {
    id: 'agentConversionPage_convertedAgentsInRenewalStep',
    defaultMessage: 'Sales codes "mapped" in renewal step',
  },
  //translated
  agentConversionPage_convertedDate: {
    id: 'agentConversionPage_convertedDate',
    defaultMessage: 'Start date of renewal step',
  },

  //#endregion

  //#region Common labels
  //translated
  common_optional: {
    id: 'common_optional',
    defaultMessage: 'Optional',
  },
  //translated
  common_redirecting: {
    id: 'common_redirecting',
    defaultMessage: 'Redirecting',
  },
  //translated
  common_userId: {
    id: 'common_userId',
    defaultMessage: 'User ID',
  },
  //new
  common_codePrefix: {
    id: 'common_codePrefix',
    defaultMessage: 'Code Prefix',
  },
  //new
  common_agentCode: {
    id: 'common_agentCode',
    defaultMessage: 'Agent Code',
  },
  //translated
  common_costCenter: {
    id: 'common_costCenter',
    defaultMessage: 'Cost Center',
  },
  //translated
  common_name: {
    id: 'common_name',
    defaultMessage: 'Name',
  },
  //translated
  common_bankAccount: {
    id: 'common_bankAccount',
    defaultMessage: 'Bank account',
  },
  //translated
  common_typeOfAccount: {
    id: 'common_typeOfAccount',
    defaultMessage: 'Type of account',
  },
  //new
  common_inherited: {
    id: 'common_inherited',
    defaultMessage: 'Inherited',
  },
  //translated
  common_invalid: {
    id: 'common_invalid',
    defaultMessage: 'Invalid',
  },
  //translated
  common_cancel: {
    id: 'common_cancel',
    defaultMessage: 'Cancel',
  },
  //translated
  common_externalSalesCode: {
    id: 'common_externalSalesCode',
    defaultMessage: 'External sales code',
  },
  //translated
  common_goToSearch: {
    id: 'common_goToSearch',
    defaultMessage: 'Go to search',
  },
  //translated
  common_close: {
    id: 'common_close',
    defaultMessage: 'Close',
  },
  //translated
  common_edit: {
    id: 'common_edit',
    defaultMessage: 'Edit',
  },
  //translated
  common_updatedBy: {
    id: 'common_updatedBy',
    defaultMessage: 'Updated By',
  },
  //translated
  common_activationDate: {
    id: 'common_activationDate',
    defaultMessage: 'Activation date',
  },
  //new
  common_update: {
    id: 'common_update',
    defaultMessage: 'Update',
  },
  //translated
  common_create: {
    id: 'common_create',
    defaultMessage: 'Create',
  },
  //translated
  common_bankName: {
    id: 'common_bankName',
    defaultMessage: 'Bank name',
  },
  //translated
  common_additionalName: {
    id: 'common_additionalName',
    defaultMessage: 'Additional name',
  },
  //translated
  common_save: {
    id: 'common_save',
    defaultMessage: 'Save',
  },
  //new
  common_ok: {
    id: 'common_ok',
    defaultMessage: 'Ok',
  },
  //new
  common_parentTeam: {
    id: 'common_parentTeam',
    defaultMessage: 'Parent team',
  },
  //new
  common_teamName: {
    id: 'common_teamName',
    defaultMessage: 'Team name',
  },
  //new
  common_mobile: {
    id: 'common_mobile',
    defaultMessage: 'Mobile',
  },
  //new
  common_address: {
    id: 'common_address',
    defaultMessage: 'Address',
  },
  //translated
  common_email: {
    id: 'common_email',
    defaultMessage: 'Email',
  },
  //new
  common_incorrectEmailFormat: {
    id: 'common_incorrectEmailFormat',
    defaultMessage: 'Email is not in correct format',
  },
  //translated
  common_phone: {
    id: 'common_phone',
    defaultMessage: 'Phone',
  },
  //new
  common_legalNumber: {
    id: 'common_legalNumber',
    defaultMessage: 'Legal number',
  },
  //new
  common_country: {
    id: 'common_country',
    defaultMessage: 'Country',
  },
  //translated
  common_missingValue: {
    id: 'common_missingValue',
    defaultMessage: 'Missing value',
  },
  //new
  common_codePrefixIncorrect: {
    id: 'common_codePrefixIncorrect',
    defaultMessage: 'Code prefix is not in a correct format!',
  },

  //#endregion

  //#region Breadcrumbs
  //translated
  breadcrumb_searchPage: {
    id: 'breadcrumb_searchPage',
    defaultMessage: 'Sales Agent',
  },
  //new
  breadcrumb_teamPage: {
    id: 'breadcrumb_teamPage',
    defaultMessage: 'Team',
  },
  //translated
  breadcrumb_commissionPage: {
    id: 'breadcrumb_commissionPage',
    defaultMessage: 'Commission',
  },
  //new
  breadcrumb_agentConversionPage: {
    id: 'breadcrumb_agentConversionPage',
    defaultMessage: 'Agent conversions',
  },
  //new
  breadcrumb_employerPage: {
    id: 'breadcrumb_employerPage',
    defaultMessage: 'Employer',
  },
  //new
  breadcrumb_splitSalesPage: {
    id: 'breadcrumb_splitSalesPage',
    defaultMessage: 'Split sales',
  },

  //#endregion

  //#region Errors

  //new
  error_CodePrefixExists: {
    id: 'error_CodePrefixExists',
    defaultMessage: 'Provided code prefix already exists',
  },
  //new
  error_serverError: {
    id: 'error_serverError',
    defaultMessage: 'Server: {message}',
  },
  //new
  error_addressNotFound: {
    id: 'error_addressNotFound',
    defaultMessage: 'No address found!',
  },
  //new
  error_commissionHistory: {
    id: 'error_commissionHistory',
    defaultMessage: "Something wen't wrong while loading history data",
  },

  //#endregion

  //#region Search page
  //new
  searchPage_createTeamButton: {
    id: 'searchPage_createTeamButton',
    defaultMessage: 'Create Team',
  },
  //new
  searchPage_searchQueryNotValid: {
    id: 'searchPageQueryNotValid',
    defaultMessage: 'Your query "{query}" is not valid',
  },
  //new
  searchPage_noResultsForTeam: {
    id: 'searchPage_noResultsForTeam',
    defaultMessage: 'Your search "{query}" gave 0 hits from sales agent registry. No record found in If´s system',
  },
  //new
  searchPage_headerTeam: {
    id: 'searchPage_headerTeam',
    defaultMessage: 'Team',
  },
  //new
  searchPage_headerEmployer: {
    id: 'searchPage_headerEmployer',
    defaultMessage: 'Employer',
  },
  //new
  searchPage_searchTitleEmployer: {
    id: 'searchPage_searchTitleEmployer',
    defaultMessage: 'Search for Employers',
  },
  //new
  searchPage_searchTitleTeam: {
    id: 'searchPage_searchTitleTeam',
    defaultMessage: 'Search for Teams',
  },
  //new
  searchPage_employerNoResults: {
    id: 'searchPage_employerNoResults',
    defaultMessage: 'No employers found based on your search criteria.',
  },
  //new
  searchPage_createEmployerButton: {
    id: 'searchPage_createEmployerButton',
    defaultMessage: 'Create Employer',
  },
  //new
  searchPage_chooseCategory: {
    id: 'searchPage_chooseCategory',
    defaultMessage: 'Choose search category:',
  },
  //#endregion

  //#region Team page

  //new
  teamPage_hideHistoricalAgents: {
    id: 'teamPage_hideHistoricalAgents',
    defaultMessage: 'Hide historical agent codes',
  },
  //new
  teamPage_showHistoricalAgents: {
    id: 'teamPage_showHistoricalAgents',
    defaultMessage: 'Show historical agent codes',
  },
  //new
  teamPage_notSupportedModalType: {
    id: 'teamPage_notSupportedModalType',
    defaultMessage: 'Cannot open specified modal, no such type exists.',
  },
  //new
  teamPage_agentNotFound: {
    id: 'teamPage_agentNotFound',
    defaultMessage: 'Cannot find active agent with code {agentCode}',
  },

  //new
  teamPage_linkError_goToTeamPage: {
    id: 'teamPage_linkError_goToTeamPage',
    defaultMessage: 'Go to Team page',
  },
  //new
  teamPage_linkError_description: {
    id: 'teamPage_linkError_description',
    defaultMessage: 'Try going to Team page and manually opening correct modal',
  },

  //new
  teamPage_teamHeader_teamAddressName: {
    id: 'teamPage_teamHeader_teamAddressName',
    defaultMessage: 'Team address',
  },
  //new
  teamPage_teamHeader_showMore: {
    id: 'teamPage_teamHeader_showMore',
    defaultMessage: 'Show more',
  },
  //new
  teamPage_teamHeader_showLess: {
    id: 'teamPage_teamHeader_showLess',
    defaultMessage: 'Show less',
  },

  //translated
  headerMenu_viewBankLog: {
    id: 'headerMenu_viewBankLog',
    defaultMessage: 'View bank account log',
  },
  //translated
  headerMenu_copyCostCenters: {
    id: 'headerMenu_copyCostCenters',
    defaultMessage: 'Copy Cost center (s) to new user',
  },
  //new
  headerMenu_editAddress: {
    id: 'headerMenu_editAddress',
    defaultMessage: 'Edit Address',
  },
  //new
  headerMenu_viewAddressLog: {
    id: 'headerMenu_viewAddressLog',
    defaultMessage: 'Address Change Log',
  },
  //translated
  headerMenu_editBankAccount: {
    id: 'headerMenu_editBankAccount',
    defaultMessage: 'Edit bank account',
  },
  //translated
  headerMenu_commissionPage: {
    id: 'headerMenu_commissionPage',
    defaultMessage: 'Commission',
  },
  //translated
  headerMenu_revokeAgent: {
    id: 'headerMenu_revokeAgent',
    defaultMessage: 'Revoke',
  },
  //new
  headerMenu_setDefaultAgent: {
    id: 'headerMenu_setDefaultAgent',
    defaultMessage: 'Set agent code as default',
  },
  //new
  headerMenu_openHierarchyView: {
    id: 'headerMenu_openHierarchyView',
    defaultMessage: 'See hierarchy ',
  },

  //new
  activeAgents_isAddressInherited: {
    id: 'activeAgents_isAddressInherited',
    defaultMessage: 'Is address inherited',
  },
  //new
  activeAgents_isDefaultAgent: {
    id: 'activeAgents_isDefaultAgent',
    defaultMessage: 'Is default',
  },
  //translated
  activeAgents_notApplicable: {
    id: 'activeAgents_notApplicable',
    defaultMessage: 'Not applicable',
  },
  //new
  activeAgents_addAgentCode: {
    id: 'activeAgents_addAgentCode',
    defaultMessage: 'Add new agent',
  },
  //new
  activeAgents_commission: {
    id: 'activeAgents_commission',
    defaultMessage: 'Commission',
  },

  //translated
  historicalAgents_endDate: {
    id: 'historicalAgents_endDate',
    defaultMessage: 'End date',
  },
  //new
  historicalAgents_modalTitle: {
    id: 'historicalAgents_modalTitle',
    defaultMessage: 'Historical {agentCode}',
  },
  //new
  historicalAgents_reactivateButton: {
    id: 'historicalAgents_reactivateButton',
    defaultMessage: 'Reactivate',
  },

  //new
  teamInfo_titleTextNewTeam: {
    id: 'teamInfo_titleTextNewTeam',
    defaultMessage: 'Create new team',
  },
  //new
  teamInfo_titleTextEditTeam: {
    id: 'teamInfo_titleTextEditTeam',
    defaultMessage: 'Edit team {codePrefix}',
  },
  //new
  teamInfo_createNewTeamButton: {
    id: 'teamInfo_createNewTeamButton',
    defaultMessage: 'Create new team',
  },
  //new
  teamInfo_teamNotFound: {
    id: 'teamInfo_teamNotFound',
    defaultMessage: 'The team {codePrefix} was not found!',
  },
  //translated
  teamInfo_userIdNotFound: {
    id: 'teamInfo_userIdNotFound',
    defaultMessage: 'User ID not found',
  },
  //new
  teamInfo_parentTeamNotFound: {
    id: 'teamInfo_parentTeamNotFound',
    defaultMessage: 'Parent team not found',
  },
  //new
  teamInfo_parentTeamRecursive: {
    id: 'teamInfo_parentTeamRecursive',
    defaultMessage: 'Cannot establish the recursive parent team',
  },
  //new
  teamInfo_teamType: {
    id: 'teamInfo_teamType',
    defaultMessage: 'Team type',
  },
  //new
  teamInfo_teamResponsibleType: {
    id: 'teamInfo_teamResponsibleType',
    defaultMessage: 'Type',
  },

  //translated
  agentInfo_digital: {
    id: 'agentInfo_digital',
    defaultMessage: 'Digital',
  },
  //translated
  agentInfo_groupEmail: {
    id: 'agentInfo_groupEmail',
    defaultMessage: 'Alert email',
  },
  //translated
  agentInfo_xmlExport: {
    id: 'agentInfo_xmlExport',
    defaultMessage: 'XML export',
  },
  //translated
  agentInfo_canBePortfolioResponsible: {
    id: 'agentInfo_canBePortfolioResponsible',
    defaultMessage: 'Can be portfolio responsible',
  },
  //translated
  agentInfo_channel: {
    id: 'agentInfo_channel',
    defaultMessage: 'Channel',
  },
  //translated
  agentInfo_region: {
    id: 'agentInfo_region',
    defaultMessage: 'Region',
  },
  //translated
  agentInfo_costCenter: {
    id: 'agentInfo_costCenter',
    defaultMessage: 'Cost center',
  },
  //new
  agentInfo_employer: {
    id: 'agentInfo_employer',
    defaultMessage: 'Employer',
  },
  //new
  agentInfo_salesCommission: {
    id: 'agentInfo_salesCommission',
    defaultMessage: 'Enable sales commission AIF',
  },
  //new
  agentInfo_commissionModel: {
    id: 'agentInfo_commissionModel',
    defaultMessage: 'Commission model',
  },
  //new
  agentInfo_commissionModel_AssurandorIIF: {
    id: 'agentInfo_commissionModel_AssurandorIIF',
    defaultMessage: 'Assurandør i iF',
  },
  //new
  agentInfo_commissionModel_externalSalesDK: {
    id: 'agentInfo_commissionModel_externalSalesDK',
    defaultMessage: 'External Sales DK',
  },
  //new
  agentInfo_employeeNumber: {
    id: 'agentInfo_employeeNumber',
    defaultMessage: 'Employee number',
  },

  //new
  agentBankAccount_teamBankAccountNotSet: {
    id: 'agentBankAccount_teamBankAccountNotSet',
    defaultMessage: 'Create bank account on team level first',
  },
  //new
  agentBankAccount_typeNotSet: {
    id: 'agentBankAccount_typeNotSet',
    defaultMessage: 'Bank account type should not be empty!',
  },
  //translated
  agentBankAccount_title: {
    id: 'agentBankAccount_title',
    defaultMessage: 'Editing bank account for {agentCode}',
  },

  //translated
  bankAccountLog_title: {
    id: 'bankAccountLog_title',
    defaultMessage: 'Bank account log for {agentCode}',
  },
  //translated
  bankAccountLog_type: {
    id: 'bankAccountLog_type',
    defaultMessage: 'Bank account type',
  },
  //translated
  bankAccountLog_updatedAt: {
    id: 'bankAccountLog_updatedAt',
    defaultMessage: 'Updated',
  },

  //new
  copyCostCenters_costCenterNotSelected: {
    id: 'copyCostCenters_costCenterNotSelected',
    defaultMessage: 'At least one cost center must be selected',
  },
  //new
  copyCostCenters_navigateToNewTeam: {
    id: 'copyCostCenters_navigateToNewTeam',
    defaultMessage: 'Go to new team',
  },
  //new
  copyCostCenters_create: {
    id: 'copyCostCenters_create',
    defaultMessage: 'Copy and create',
  },
  //translated
  copyCostCenters_title: {
    id: 'copyCostCenters_title',
    defaultMessage: 'Copy cost center (s) to new user',
  },
  //translated
  copyCostCenters_chooseAll: {
    id: 'copyCostCenters_chooseAll',
    defaultMessage: 'Choose all',
  },

  //new
  revokeConfirmation_agentRevoked: {
    id: 'revokeConfirmation_agentRevoked',
    defaultMessage: 'Agent {agentCode} was revoked successfully',
  },
  //new
  revokeConfirmation_agentRemoved: {
    id: 'revokeConfirmation_agentRemoved',
    defaultMessage: 'Agent {agentCode} was removed, since it was never active',
  },
  //new
  revokeConfirmation_teamDeleted: {
    id: 'revokeConfirmation_teamDeleted',
    defaultMessage: 'The team has been deleted, since agent has never been active',
  },
  //translated
  revokeConfirmation_yesRevoke: {
    id: 'revokeConfirmation_yesRevoke',
    defaultMessage: 'Yes, revoke',
  },
  //new
  revokeConfirmation_title: {
    id: 'revokeConfirmation_title',
    defaultMessage: 'Revoke agent code',
  },

  //new
  addressLog_timeStamp: {
    id: 'addressLog_timeStamp',
    defaultMessage: 'When',
  },
  //new
  addressLog_address: {
    id: 'addressLog_address',
    defaultMessage: 'Address',
  },
  //new
  addressLog_title: {
    id: 'addressLog_title',
    defaultMessage: 'Address change log for ',
  },

  //new
  defaultAgent_setDefaultAgentCode: {
    id: 'defaultAgent_setDefaultAgentCode',
    defaultMessage: 'Set agent code as default',
  },
  //new
  defaultAgent_confirmation: {
    id: 'defaultAgent_confirmation',
    defaultMessage: 'Set default',
  },

  //new
  addressInfo_additionalLine: {
    id: 'addressInfo_additionalLine',
    defaultMessage: 'Additional Address Line',
  },
  //new
  addressInfo_apartmentNumber: {
    id: 'addressInfo_apartmentNumber',
    defaultMessage: 'Apartment Number',
  },
  //new
  addressInfo_houseLetter: {
    id: 'addressInfo_houseLetter',
    defaultMessage: 'Letter',
  },
  //new
  addressInfo_houseNumber: {
    id: 'addressInfo_houseNumber',
    defaultMessage: 'Number',
  },
  //new
  addressInfo_streetName: {
    id: 'addressInfo_streetName',
    defaultMessage: 'Street name',
  },
  //new
  addressInfo_addressLine: {
    id: 'addressInfo_addressLine',
    defaultMessage: 'Address Line {lineNumber}',
  },
  //new
  addressInfo_postBoxNumber: {
    id: 'addressInfo_postBoxNumber',
    defaultMessage: 'Box number',
  },
  //new
  addressInfo_postBoxName: {
    id: 'addressInfo_postBoxName',
    defaultMessage: 'Box name',
  },
  //new
  addressInfo_city: {
    id: 'addressInfo_city',
    defaultMessage: 'City',
  },
  //new
  addressInfo_cityPlaceholder: {
    id: 'addressInfo_cityPlaceholder',
    defaultMessage: 'Auto filled by postal code',
  },
  //new
  addressInfo_searchPlaceholder: {
    id: 'addressInfo_searchPlaceholder',
    defaultMessage: 'Search addresses',
  },
  //new
  addressInfo_addCo: {
    id: 'addressInfo_addCo',
    defaultMessage: 'Add C/o',
  },
  //new
  addressInfo_removeCo: {
    id: 'addressInfo_removeCo',
    defaultMessage: 'Remove C/o',
  },
  //new
  addressInfo_coType: {
    id: 'addressInfo_coType',
    defaultMessage: 'Type',
  },
  //new
  addressInfo_coName: {
    id: 'addressInfo_coName',
    defaultMessage: 'C/o',
  },
  //new
  addressInfo_postalCode: {
    id: 'addressInfo_postalCode',
    defaultMessage: 'Postal code',
  },
  //new
  addressInfo_checkBox: {
    id: 'addressInfo_checkBox',
    defaultMessage: 'Is address inherited from sales id',
  },
  //new
  addressInfo_create: {
    id: 'addressInfo_create',
    defaultMessage: 'Create address',
  },
  //new
  addressInfo_edit: {
    id: 'addressInfo_edit',
    defaultMessage: 'Edit address',
  },
  //new
  addressInfo_errorCreate: {
    id: 'addressInfo_errorCreate',
    defaultMessage: 'Create new address',
  },
  //new
  addressInfo_errorAddressNotFound: {
    id: 'addressInfo_errorAddressNotFound',
    defaultMessage: 'Address not found',
  },
  //new
  addressInfo_errorSelectExistingAddress: {
    id: 'addressInfo_errorSelectExistingAddress',
    defaultMessage: 'Select existing addresses from agents',
  },
  //new
  addressInfo_warning: {
    id: 'addressInfo_warning',
    defaultMessage: 'You are about to assign an address which is already set on Sales Id level.',
  },
  //new
  addressInfo_warningQuestion: {
    id: 'addressInfo_warningQuestion',
    defaultMessage: 'Do you want to continue or inherit the address?',
  },
  //new
  addressInfo_warningInherit: {
    id: 'addressInfo_warningInherit',
    defaultMessage: 'Inherit',
  },
  //new
  addressInfo_warningContinue: {
    id: 'addressInfo_warningContinue',
    defaultMessage: 'Continue',
  },
  //new
  addressInfo_StreetAddress: {
    id: 'addressInfo_StreetAddress',
    defaultMessage: 'Street Address',
  },
  //new
  addressInfo_ForeignAddress: {
    id: 'addressInfo_ForeignAddress',
    defaultMessage: 'Foreign Address',
  },
  //new
  addressInfo_FreeTextAddressNotSupported: {
    id: 'addressInfo_FreeTextAddressNotSupported',
    defaultMessage: 'Free text address is no longer supported, please switch to another format.',
  },
  //new
  addressInfo_UnstructuredAddress: {
    id: 'addressInfo_UnstructuredAddress',
    defaultMessage: 'Unstructured Address',
  },
  //new
  addressInfo_POBoxAddress: {
    id: 'addressInfo_POBoxAddress',
    defaultMessage: 'Post Box Address',
  },
  //new
  addressInfo_postalCodeWrongFormat: {
    id: 'addressInfo_postalCodeWrongFormat',
    defaultMessage: 'Postal code is not in correct format!',
  },
  //new
  addressInfo_postalCodeIsIncorrect: {
    id: 'addressInfo_postalCodeIsIncorrect',
    defaultMessage: 'Cannot find provided postal code!',
  },

  //new
  teamHierarchy_title: {
    id: 'teamHierarchy_title',
    defaultMessage: 'Team hierarchy',
  },
  //new
  teamHierarchy_createNewTeam: {
    id: 'teamHierarchy_createNewTeam',
    defaultMessage: 'Create new team',
  },

  //#endregion

  //#region Commission page

  //translated
  commissionPage_rateTypeProperty: {
    id: 'commissionPage_rateTypeProperty',
    defaultMessage: 'Property',
  },
  //translated
  commissionPage_rateTypeLiability: {
    id: 'commissionPage_rateTypeLiability',
    defaultMessage: 'Liability',
  },
  //translated
  commissionPage_rateTypePerson: {
    id: 'commissionPage_rateTypePerson',
    defaultMessage: 'Person',
  },
  //translated
  commissionPage_rateTypeTransport: {
    id: 'commissionPage_rateTypeTransport',
    defaultMessage: 'Transport',
  },
  //translated
  commissionPage_rateTypeCasco: {
    id: 'commissionPage_rateTypeCasco',
    defaultMessage: 'Casco',
  },
  //translated
  commissionPage_rateTypePersonalCommission: {
    id: 'commissionPage_rateTypePersonalCommission',
    defaultMessage: 'Personal Commission',
  },
  //translated
  commissionPage_rateTypeMotorCommission: {
    id: 'commissionPage_rateTypeMotorCommission',
    defaultMessage: 'Motor Commission',
  },
  //translated
  commissionPage_Updated: {
    id: 'commissionPage_Updated',
    defaultMessage: 'Updated',
  },
  //translated
  commissionPage_ValidTo: {
    id: 'commissionPage_ValidTo',
    defaultMessage: 'Valid to',
  },
  //translated
  commissionPage_ValidFrom: {
    id: 'commissionPage_ValidFrom',
    defaultMessage: 'Valid from',
  },
  //translated
  commissionPage_useBrokerCost: {
    id: 'commissionPage_useBrokerCost',
    defaultMessage: 'Use broker cost',
  },
  //translated
  commissionPage_usePersonalCommission: {
    id: 'commissionPage_usePersonalCommission',
    defaultMessage: 'Use personal commission',
  },
  //translated
  commissionPage_useMotorCommission: {
    id: 'commissionPage_useMotorCommission',
    defaultMessage: 'Use motor commission',
  },
  //translated
  commissionPage_inheritCommissionHandling: {
    id: 'commissionPage_inheritCommissionHandling',
    defaultMessage: 'Inherit commission handling',
  },
  //translated
  commissionPage_mappedToIfLogin: {
    id: 'commissionPage_mappedToIfLogin',
    defaultMessage: 'Mapped to IfLogin',
  },
  //translated
  commissionPage_historicalRecordsTitle: {
    id: 'commissionPage_historicalRecordsTitle',
    defaultMessage: 'Historical commission',
  },
  //translated
  commissionPage_brokerCostAcceptance: {
    id: 'commissionPage_brokerCostAcceptance',
    defaultMessage: 'Broker cost acceptance',
  },
  //translated
  commissionPage_personalAcceptance: {
    id: 'commissionPage_personalAcceptance',
    defaultMessage: 'Personal acceptance',
  },
  //translated
  commissionPage_motorAcceptance: {
    id: 'commissionPage_motorAcceptance',
    defaultMessage: 'Motor acceptance',
  },
  //translated
  commissionPage_waypointNumber: {
    id: 'commissionPage_waypointNumber',
    defaultMessage: 'Waypoint number',
  },
  //translated
  commissionPage_customer: {
    id: 'commissionPage_customer',
    defaultMessage: 'Customer',
  },
  //translated
  commissionPage_organizationNumber: {
    id: 'commissionPage_organizationNumber',
    defaultMessage: 'Organization number',
  },
  //translated
  commissionPage_customerDropdownPlaceholder: {
    id: 'commissionPage_customerDropdownPlaceholder',
    defaultMessage: 'WP number, legal number or name',
  },
  //translated
  commissionPage_customerDropdownNewCustomer: {
    id: 'commissionPage_customerDropdownNewCustomer',
    defaultMessage: 'Add new customer',
  },
  //new
  commissionPage_modalTitleCreateDefaultRate: {
    id: 'commissionPage_modalTitleCreateDefaultRate',
    defaultMessage: 'Set default rates for agent',
  },
  //new
  commissionPage_modalTitleEditDefaultRate: {
    id: 'commissionPage_modalTitleEditDefaultRate',
    defaultMessage: 'Edit default agent rates',
  },
  //new
  commissionPage_modalTitleNewCustomerRate: {
    id: 'commissionPage_modalTitleNewCustomerRate',
    defaultMessage: 'Create new custom rate for customer',
  },
  //new
  commissionPage_modalTitleEditCustomerRate: {
    id: 'commissionPage_modalTitleEditCustomerRate',
    defaultMessage: 'Edit agent rates for {customerNumber}',
  },
  //new
  commissionPage_customerSearchNotFound: {
    id: 'commissionPage_customerSearchNotFound',
    defaultMessage: 'No customers were found.',
  },
  //new
  commissionPage_customerSearchResults: {
    id: 'commissionPage_customerSearchResults',
    defaultMessage: 'Search results:',
  },
  //new
  commissionPage_customerSearchPlaceholder: {
    id: 'commissionPage_customerSearchPlaceholder',
    defaultMessage: 'Find customers',
  },
  //translated
  commissionPage_customerLookupPlaceholder: {
    id: 'commissionPage_customerLookupPlaceholder',
    defaultMessage: 'WP number, legal number or name',
  },
  //new
  commissionPage_customerLookupNewButton: {
    id: 'commissionPage_customerLookupNewButton',
    defaultMessage: 'Create new',
  },
  //new
  commissionPage_customerLookupNotFound: {
    id: 'commissionPage_customerLookupNotFound',
    defaultMessage: 'No customer specific rates were found.',
  },
  //new
  commissionPage_customerExistsForAgent: {
    id: 'commissionPage_customerExistsForAgent',
    defaultMessage: 'Agent already has custom rates for this customer',
  },
  //new
  commissionPage_customerNotSelected: {
    id: 'commissionPage_customerNotSelected',
    defaultMessage: 'Please select customer',
  },
  //new
  commissionPage_selectedCustomer: {
    id: 'commissionPage_selectedCustomer',
    defaultMessage: 'Selected customer {customerNumber} {customerName} {legalNumber}',
  },

  //#endregion

  //#region Error page

  //translated
  errorPage_tryToRefresh: {
    id: 'errorPage_tryToRefresh',
    defaultMessage: 'Try to refresh',
  },
  //translated
  errorPage_error: {
    id: 'errorPage_error',
    defaultMessage: 'Error',
  },
  //translated
  errorPage_title: {
    id: 'errorPage_title',
    defaultMessage: 'Something went wrong',
  },
  salesIdNotFound: {
    id: 'salesIdNotFound',
    defaultMessage: 'Sales ID not found',
  },
  salesIdNotFoundDescription: {
    id: 'salesIdNotFoundDescription',
    defaultMessage: 'The requested sales ID could not be found.',
  },

  //#endregion

  //#region Employer page

  //new
  employerPage_agentTableTitle: {
    id: 'employerPage_agentTableTitle',
    defaultMessage: 'Agents connected to employer',
  },
  //new
  employerPage_header_editAddress: {
    id: 'employerPage_header_editAddress',
    defaultMessage: 'Edit address',
  },
  //new
  employerPage_header_connectedTeams: {
    id: 'employerPage_header_connectedTeams',
    defaultMessage: 'Connected teams',
  },

  //new
  employerPage_removeAgent_title: {
    id: 'employerPage_removeAgent_title',
    defaultMessage: 'Remove agent connection',
  },
  //new
  employerPage_removeAgent_text: {
    id: 'employerPage_removeAgent_text',
    defaultMessage: 'Are you sure you want to remove connection to agent {agentCode}?',
  },
  //new
  employerPage_removeAgent_accept: {
    id: 'employerPage_removeAgent_accept',
    defaultMessage: 'Remove connection',
  },

  //new
  employerPage_employerInfo_title: {
    id: 'employerPage_employerInfo_title',
    defaultMessage: 'Employer information',
  },

  //new
  employerPage_connectAgent_title: {
    id: 'employerPage_connectAgent_title',
    defaultMessage: 'Connect agent to employer',
  },
  //new
  employerPage_connectAgent_button: {
    id: 'employerPage_connectAgent_button',
    defaultMessage: 'Connect',
  },
  //new
  employerPage_connectAgent_placeholder: {
    id: 'employerPage_connectAgent_placeholder',
    defaultMessage: 'Enter agent code',
  },
  //new
  employerPage_connectAgent_notCorrectFormat: {
    id: 'employerPage_connectAgent_notCorrectFormat',
    defaultMessage: 'Incorrect agent code format',
  },
  //new
  employerPage_connectAgent_alreadyConnected: {
    id: 'employerPage_connectAgent_alreadyConnected',
    defaultMessage: 'Agent is already connected to employer',
  },

  //new
  employerPage_connectedTeams_title: {
    id: 'employerPage_connectedTeams_title',
    defaultMessage: 'Connected teams',
  },
  //new
  employerPage_connectedTeams_agentCount: {
    id: 'employerPage_connectedTeams_agentCount',
    defaultMessage: 'Connected agents',
  },
  //new
  employerPage_connectedTeams_accept: {
    id: 'employerPage_connectedTeams_accept',
    defaultMessage: 'Remove connection',
  },
  //new
  employerPage_connectedTeams_newTeam: {
    id: 'employerPage_connectedTeams_newTeam',
    defaultMessage: 'Connect new team',
  },
  //new
  employerPage_connectedTeams_removeTeamWarning: {
    id: 'employerPage_connectedTeams_removeTeamWarning',
    defaultMessage: 'Are you sure you want to remove connection from team {codePrefix}?',
  },
  //new
  employerPage_connectedTeams_notFound: {
    id: 'employerPage_connectedTeams_notFound',
    defaultMessage: 'No team has been connected to this employer yet.',
  },
  //new
  employerPage_connectedTeams_searchTeamTitle: {
    id: 'employerPage_connectedTeams_searchTeamTitle',
    defaultMessage: 'Search for teams to connect',
  },
  //new
  employerPage_connectedTeams_searchTeamButton: {
    id: 'employerPage_connectedTeams_searchTeamButton',
    defaultMessage: 'Connect',
  },

  //new
  employerPage_employerAddress_title: {
    id: 'employerPage_employerAddress_title',
    defaultMessage: 'Employer address',
  },

  //new
  customHeader_settings_useEnglish: {
    id: 'customHeader_settings_useEnglish',
    defaultMessage: 'Use English',
  },
  //new
  customHeader_settings_businessArea: {
    id: 'customHeader_settings_businessArea',
    defaultMessage: 'Business area',
  },
  //new
  customHeader_settings_legalUnit: {
    id: 'customHeader_settings_legalUnit',
    defaultMessage: 'Legal unit',
  },
  //new
  customHeader_settings_sweden: {
    id: 'customHeader_settings_sweden',
    defaultMessage: 'Sweden',
  },
  //new
  customHeader_settings_norway: {
    id: 'customHeader_settings_norway',
    defaultMessage: 'Norway',
  },
  //new
  customHeader_settings_denmark: {
    id: 'customHeader_settings_denmark',
    defaultMessage: 'Denmark',
  },
  //new
  customHeader_settings_finland: {
    id: 'customHeader_settings_finland',
    defaultMessage: 'Finland',
  },
  //new
  customHeader_settings_private: {
    id: 'customHeader_settings_private',
    defaultMessage: 'Private',
  },
  //new
  customHeader_settings_commercial: {
    id: 'customHeader_settings_commercial',
    defaultMessage: 'Commercial',
  },
  //new
  customHeader_error_cannotFetch: {
    id: 'customHeader_error_cannotFetch',
    defaultMessage: 'Failed to fetch preferences',
  },
  //new
  customHeader_error_cannotUpdate: {
    id: 'customHeader_error_cannotUpdate',
    defaultMessage: 'Failed to update preferences',
  },

  //#endregion

  //#region Split sales page

  //new
  splitSales_policyVersionLabel: {
    id: 'splitSales_policyVersionLabel',
    defaultMessage: 'Policy number',
  },
  //new
  splitSales_agentCodeLabel: {
    id: 'splitSales_agentCodeLabel',
    defaultMessage: 'Primary agent code',
  },
  //new
  splitSales_searchBoxLabel: {
    id: 'splitSales_searchBoxLabel',
    defaultMessage: 'Search for co-signer',
  },
  //new
  splitSales_searchBoxPlaceholder: {
    id: 'splitSales_searchBoxPlaceholder',
    defaultMessage: 'Search by agent code',
  },
  //new
  splitSales_splitPercentageLabel: {
    id: 'splitSales_splitPercentageLabel',
    defaultMessage: 'Split ratio',
  },
  //new
  splitSales_clearFields: {
    id: 'splitSales_clearFields',
    defaultMessage: 'Clear fields',
  },
  //new
  splitSales_coAgentLabel: {
    id: 'splitSales_coAgentLabel',
    defaultMessage: 'Co-signer agent code',
  },

  //#endregion
});

export default Messages;
